var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClockicon = function SvgClockicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.5 5a.5.5 0 0 0-.5.5V9.13a.5.5 0 0 0 .21.407l3.197 2.284a.5.5 0 0 0 .698-.116l.29-.407a.5.5 0 0 0-.116-.698L8.71 8.764a.5.5 0 0 1-.209-.407V5.5A.5.5 0 0 0 8 5h-.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 8.5a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm1.6 0a6.4 6.4 0 1 0 12.8 0 6.4 6.4 0 0 0-12.8 0Z",
    clipRule: "evenodd"
  })));
};
export default SvgClockicon;